export const SCROLL_THRESHOLDS = [25, 50, 75, 100] as const
export const SCROLL_EVENT = 'view_user_scroll'
